import { create } from "zustand";

interface DiffOnlyChangesState {
	enabled: boolean;
	updateEnabled: (enabled: boolean) => void;
}

const useDiffOnlyChangesStore = create<DiffOnlyChangesState>()((set) => ({
	enabled: false,
	updateEnabled: (enabled: boolean) => set({ enabled }),
}));

export const useOnlyChangesEnabled = () => useDiffOnlyChangesStore((state) => state.enabled);

export const setOnlyChangesEnabled = (enabled: boolean) => {
	useDiffOnlyChangesStore.getState().updateEnabled(enabled);
};
